import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientHelperService } from './http-client-helper.service';
import { AiAgentResponse, AiAgentShallowTaskResponse, AiAgentTaskResponse } from './models/ai-agents/ai-agents.interface';
import { AiAgentEnum, EntityTypeEnum } from './models/ai-agents/ai-agents.enum';
import { HttpParams } from '@angular/common/http';
@Injectable({
  	providedIn: 'root'
})
export class ApiClientAiAgentsService {

	private readonly controller = 'ai-agents';

  	constructor(private httpClientHelper: HttpClientHelperService) { }

	getAiAgents(): Observable<AiAgentResponse[]> {
        return this.httpClientHelper.invokeGetAuth<AiAgentResponse[]>(`${this.controller}`);
	}

	getAiAgentById(miraId: AiAgentEnum): Observable<AiAgentResponse> {
        return this.httpClientHelper.invokeGetAuth<AiAgentResponse>(`${this.controller}/${miraId}`);
	}

	getAiAgentShallowTasks(miraId: AiAgentEnum, entityType?: EntityTypeEnum, entityId?: string): Observable<AiAgentShallowTaskResponse[]> {	
		let qParams = new HttpParams();

		qParams = qParams.appendAll({ miraId: miraId });

		if (entityType) {
			qParams = qParams.appendAll({ entityType: entityType });
		}
		if (entityId) {
			qParams = qParams.appendAll({ entityId: entityId });
		}
        return this.httpClientHelper.invokeGetAuth<AiAgentTaskResponse[]>(`${this.controller}/tasks`, qParams);
	}

	patchAiAgent(miraId: AiAgentEnum, aiAgent: Partial<AiAgentResponse>): Observable<AiAgentResponse> {
        return this.httpClientHelper.invokePatchAuth<AiAgentResponse>(`${this.controller}/${miraId}`, aiAgent);
	}

	triggerAiAgentSample(miraId: AiAgentEnum, systemIds: string[]): Observable<void> {
        return this.httpClientHelper.invokePostAuth<void>(`${this.controller}/${miraId}/sample`, { systemIds });
	}

	getAiAgentTaskById(taskId: string): Observable<AiAgentTaskResponse> {
        return this.httpClientHelper.invokeGetAuth<AiAgentTaskResponse>(`${this.controller}/tasks/${taskId}`);
	}

	retryAiAgentTask(taskId: string): Observable<void> {
        return this.httpClientHelper.invokePostAuth<void>(`${this.controller}/tasks/${taskId}/re-run`);
	}

	addInstruction(taskId: string, instruction: string): Observable<void> {
        return this.httpClientHelper.invokePostAuth<void>(`${this.controller}/tasks/${taskId}/instructions`, { body: instruction });
	}

	deleteInstruction(taskId: string, instructionId: string): Observable<void> {
        return this.httpClientHelper.invokeDeleteAuth<void>(`${this.controller}/tasks/instructions/${instructionId}`);
	}
}
